var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  padding: ", ";\n  font-size: ", ";\n  font-family: ", ";\n"], ["\n  color: ", ";\n  background: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  padding: ", ";\n  font-size: ", ";\n  font-family: ", ";\n"]);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import PropTypes from "prop-types";
import styled from "styled-components";
var Bubble = styled.div(_templateObject, function (props) {
  return props.color ? props.color : "inherit";
}, function (props) {
  return props.background ? props.background : "inherit";
}, function (props) {
  return props.radius ? props.radius + "px" : 0;
}, function (props) {
  return props.border;
}, function (props) {
  return props.padding ? props.padding + "px" : 0;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontFamily;
});
Bubble.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  padding: PropTypes.number,
  radius: PropTypes.number,
  fontSize: PropTypes.string,
  fontFamily: PropTypes.string
};
export default Bubble;